import { render, staticRenderFns } from "./competition.vue?vue&type=template&id=64cccb58"
import script from "./competition.vue?vue&type=script&lang=js"
export * from "./competition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports